import { createImageOption, ImageOption, maybeShrinkImage } from '@src/slide/infrastructure/module/dependent/image/lazy-load/lazy-image-components';

export interface CompressResult {
    blob: Blob;
    width: number;
    height: number;
}

export type ImageCompressOptions = Partial<Pick<ImageOption, keyof ImageOption>>;

export type WithErrorHandler<T> = T & {
    onError?(error: Error): void;
};

/**
 * 图片压缩处理器
 */
export default class ImageCompressor {
    public static async compressBlob(blob: Blob, options: ImageCompressOptions = {}): Promise<CompressResult> {
        const compressOpts = Object.assign(await createImageOption(), options);
        return new Promise((resolve, reject) => {
            maybeShrinkImage(
                blob,
                compressOpts,
                (compressedBlob: Blob | null, finalWidth: number, finalHeight: number, errorCode?: number) => {
                    if (!compressedBlob || errorCode !== undefined) {
                        reject(new Error(`failed to compress image with type ${blob.type}`));
                        return;
                    }

                    resolve({ blob: compressedBlob, width: finalWidth, height: finalHeight });
                },
            );
        });
    }
}
